import * as React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Loader, LoaderSize, LoaderTheme } from '../../../../components/Loader/Loader';
import { IStore } from '../../../../../redux/initialState';

type DialogsStatusPanelProps = PropsFromRedux;

class DialogsStatusPanel extends React.Component<DialogsStatusPanelProps> {

    render() {
        let {
            refreshDialogTreeCounter,
            isDialogsRefreshingInProcess,
            project,
            conversationsInfo
        } = this.props;

        let current, all;

        if (refreshDialogTreeCounter) {
            all = refreshDialogTreeCounter.all;
        }
        current = all === 1 ? 0 : refreshDialogTreeCounter.count;

        return (
            <div
                className={`dialogs-status-panel ${isDialogsRefreshingInProcess && 'refreshing'}`}>
                <div className="dialogs-status-panel_content">
                    Running test cases:
                    <div className="dialogs-status-panel_list">
                        {project?.conversations?.map(conv => {
                            const isCompleted = conversationsInfo[conv.name] === 'completed';
                            const isStarted = conversationsInfo[conv.name] === 'started';
                            return <div key={conv.name} className="dialogs-status-panel_item">
                                <div className="dialogs-status-panel_item-icon">
                                    {isCompleted ?
                                        <i className="icon icon-alan-circle-ok" /> :
                                        <Loader size={LoaderSize.UltraSmall} theme={LoaderTheme.Dark} noMargin={true} />
                                    }
                                </div>
                                <div className="dialogs-status-panel_item-label">
                                    {conv.name}
                                </div>
                                <div className="dialogs-status-panel_item-percent">
                                    {isStarted && <>{(all !== 0 && current !== 0) ? `(${Math.round(current * 100 / all)}%)` : '(0%)'}</>}
                                </div>
                            </div>;
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps({ testMode, projectsInfo }: IStore) {
    return {
        project: projectsInfo.currentProject,
        refreshDialogTreeCounter: testMode.refreshDialogTreeCounter,
        conversationsInfo: testMode.conversationsInfo,
        isDialogsRefreshingInProcess: testMode.isDialogsRefreshingInProcess,
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}


const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(DialogsStatusPanel);